import React from 'react';
import './CustomCss.scss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TabDataDistributor from '../../Containers/TabDataDistributor';
import { Component } from 'react';
import { updateCurrentTabStatus } from '../../Redux/Actions/uiActions';
import { bindActionCreators } from 'redux';

import CSSBLACKICON from '../../../assets/icons/sideNavIcons/ic_cssBlack.png';

class CustomCss extends Component {

    componentDidMount() {
        this.selectedTab = this.props.location.pathname.split('/')[2];
        let tempArray = this.props.tabListArray.filter(elem => {
            return elem.toLowerCase().replace(/ /g, '').replace(/\//g, '') === this.selectedTab;
        });
        if (tempArray.length) {
            this.props.updateCurrentTabStatus(this.selectedTab);
        } else if (this.selectedTab === 'settings') {
            this.props.updateCurrentTabStatus(this.selectedTab);
        }
        else {
            alert('This is not a valid tab');
        }
    }

    render() {
        return (
            <>
                <div className='tab-title-wrapper'>
                    <div className='tab-title-icon-wrapper'>
                        <img src={CSSBLACKICON} name='CustomCSS' width='24px' height='24px' alt='Custom CSS' />
                    </div>
                    <span className='tab-title-text' title='Custom CSS'>Custom CSS</span>
                </div>
                <div className='tab-pane fade active in show'>
                    <TabDataDistributor
                        tempdata={this.props.editableBotData.UI_OPTIONS ? { data: this.props.editableBotData.UI_OPTIONS.CUSTOM_CSS, title: 'CUSTOM_CSS', parentArray: ['CUSTOM_CSS'], isGeneric: false } : {}}
                    />
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        selectedBotData: state.UiReducer && state.UiReducer.selectedBotData ? state.UiReducer.selectedBotData : false,
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : 'chatbot',
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : []
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateCurrentTabStatus
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomCss));